/**
 * Labstep
 *
 * @module prosemirror/components/Menu/Commands/Menu/Item/Label
 * @desc A label for element menu items
 */

import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import { Label } from 'semantic-ui-react';
import type { IMenuCommandsMenuItemLabelProps } from './types';

export const MenuCommandsMenuItemLabel: React.FC<
  IMenuCommandsMenuItemLabelProps
> = () => (
  <Label size="mini" color="yellow">
    <Icon name="star" />
    New
  </Label>
);
